import React, { useCallback, useRef, useState } from 'react';
import PropTypes from 'prop-types';

// TODO: Not implemented
export const Draggable = ({ children, reorder }) => {
  const refs = useRef([]);
  const [draggedItems, setDraggedItems] = useState(null);

  const dragStart = useCallback((position) => {
    setDraggedItems({ from: position });
  }, []);

  const dragEnter = useCallback((position) => {
    setDraggedItems((old) => ({ ...old, to: position }));
  }, []);

  const drop = useCallback(() => {
    if (draggedItems.from !== draggedItems.to) {
      reorder?.(draggedItems);
    }
    setDraggedItems(null);
  }, [draggedItems, reorder]);

  return (
    <div>
      {React.Children.map(children, (child, index) => (
        <div
          style={{
            position: 'relative',
            transform:
              draggedItems?.from === index || draggedItems?.to === index
                ? 'translateX(20px)'
                : null,
          }}
        >
          <div
            key={child.props.key}
            ref={(node) => {
              refs.current[index] = node;
            }}
            onDragStart={() => dragStart(index)}
            onDragEnter={() => dragEnter(index)}
            onDragEnd={drop}
            draggable
          >
            {child}
          </div>
        </div>
      ))}
    </div>
  );
};

Draggable.propTypes = {
  children: PropTypes.node.isRequired,
  reorder: PropTypes.func,
};
